import type { CourseKeyTimePeriod, CourseKeyTimeUnit } from '@/types/course-key';

export function formatTimePeriod(period: CourseKeyTimePeriod): string {
  const noun =
    period.unit === 'days'
      ? period.value === 1
        ? 'day'
        : 'days'
      : period.value === 1
        ? 'week'
        : 'weeks';
  return `${period.value} ${noun}`;
}

export function resolveConfigDuration(config: {
  durationValue?: number;
  durationUnit?: CourseKeyTimeUnit;
  durationWeeks: number;
}): CourseKeyTimePeriod {
  if (config.durationValue && config.durationUnit) {
    return { value: config.durationValue, unit: config.durationUnit };
  }
  return { value: config.durationWeeks, unit: 'weeks' };
}

export function resolveExtensionPeriod(fee: {
  value?: number;
  unit?: CourseKeyTimeUnit;
  weeks: number;
}): CourseKeyTimePeriod {
  if (fee.value && fee.unit) {
    return { value: fee.value, unit: fee.unit };
  }
  return { value: fee.weeks, unit: 'weeks' };
}

export function resolveInactivePeriod(fee: {
  inactiveValue?: number;
  inactiveUnit?: CourseKeyTimeUnit;
  inactiveDays: number;
}): CourseKeyTimePeriod {
  if (fee.inactiveValue && fee.inactiveUnit) {
    return { value: fee.inactiveValue, unit: fee.inactiveUnit };
  }
  return { value: fee.inactiveDays, unit: 'days' };
}

export function resolveAccessPeriod(fee: {
  accessValue?: number;
  accessUnit?: CourseKeyTimeUnit;
  accessDays: number;
}): CourseKeyTimePeriod {
  if (fee.accessValue && fee.accessUnit) {
    return { value: fee.accessValue, unit: fee.accessUnit };
  }
  return { value: fee.accessDays, unit: 'days' };
}
